const doShowPaywall = (user, lsKey) => {
  const items = JSON.parse(localStorage.getItem(lsKey)) || [];
  const { anonymous } = user;

  return anonymous && (items.length > 2);
};

export const LS_COURSE_KEY = 'course_ids';
export const LS_EXPERT_KEY = 'expert_ids';

export const checkAndShowPaywall = (user, key, showPaywall) => function checkAndShowPaywallCb(e) {
  if (doShowPaywall(user, key)) {
    e.preventDefault();
    showPaywall({ source: key });
  }
};

export const checkAndShowCoursePaywall = (user, showPaywall) => checkAndShowPaywall(user, LS_COURSE_KEY, showPaywall);

export const checkAndShowExpertPaywall = (user, showPaywall) => checkAndShowPaywall(user, LS_EXPERT_KEY, showPaywall);

const addIdToLocalStorage = (id, lsKey) => {
  const items = JSON.parse(localStorage.getItem(lsKey)) || [];

  if (!items.includes(id)) {
    localStorage.setItem(lsKey, JSON.stringify(items.concat([id])));
  }
};

export const addExpertIdToLocalStorage = id => addIdToLocalStorage(id, LS_EXPERT_KEY);


export const addCourseIdToLocalStorage = id => addIdToLocalStorage(id, LS_COURSE_KEY);
